// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { IdleQueue } from 'idlize/IdleQueue.mjs';
import React from 'react';
import { page } from '@99designs/tracking';

export class AccountsJs extends React.Component {
    componentDidMount() {
        const queue = new IdleQueue({ ensureTasksRun: true });
        this.drawSnippet = this.drawSnippet.bind(this);
        queue.pushTask(() => {
            this.drawSnippet();
        });
    }

    drawSnippet() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '/accounts/accounts.js?&bypass_segment_loading=1';
        script.async = true;
        script.onload = page;

        document.body.appendChild(script);
    }

    render() {
        return null;
    }
}
